import React from "react";
import { TextField, FormControl, Typography } from "@mui/material";

export default function TextFieldWithSuffix({
  label,
  name,
  max,
  inputLabel,
  suffix,
  type,
  // onChange,
  // defaultValue,
  ...rest
}) {
  // const [value, setValue] = React.useState(defaultValue || "");

  return (
    <div className="flex w-full">
      {label ? (
        <div className="sm:w-48 sm:text-right sm:mr-12 flex items-center justify-end">
          <Typography>{label}</Typography>
        </div>
      ) : null}
      <div className="flex-1 flex">
        <FormControl fullWidth>
          <TextField
            name={name}
            label={inputLabel}
            type={type ? type : "text"}
            max={type === "Number" ? max : ""}
            // value={value}
            // onChange={(e) => {
            //   setValue(e.target.value);
            //   onChange(e.target.value);
            // }}
            {...rest}
          />
        </FormControl>
        <div className="bg-[#ededed] w-[60px] flex items-center justify-center">
          <Typography sx={{ color: "secondary.main" }}>{suffix}</Typography>
        </div>
      </div>
    </div>
  );
}
